import { render } from "./RequestResetPassword.vue?vue&type=template&id=36a1d30a&scoped=true"
import script from "./RequestResetPassword.vue?vue&type=script&lang=js"
export * from "./RequestResetPassword.vue?vue&type=script&lang=js"

import "./RequestResetPassword.vue?vue&type=style&index=0&id=36a1d30a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a1d30a"]])

export default __exports__